import React, { useState, useEffect } from 'react';
import { Card, Typography, Collapse, Divider, message, Popover, Empty, Spin } from "antd";
import FeatherIcon from 'feather-icons-react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FetchAllNotes } from "../../../Api/Services/NotesapiServices"
import { getAllUsersData } from "../../../Api/Services/CommonApiService"
import NotesPopup from '../Popup/NotesPopup'
import { EditIcon, NotesIcon } from '../../../components/Icons/Icons';
import CustomHtmlParser from '../Email/CustomHtmlParser'

const { Text } = Typography;
const { Panel } = Collapse;

const LeadTable = ({ UrlId, NacTrigger, setNaCTrigger, refreshTrigger, tabKey }) => {
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const [leads, setLeads] = useState()
    const [popupType, setPopupType] = useState()
    const [allUsers, setAllUsers] = useState()
    const [notePopup, setNotePopup] = useState(false)
    const [noteValue, setNoteValue] = useState()
    const [page, setPage] = useState()
    const [openPage, setOpenPage] = useState(Array(leads?.length).fill(false));
    const handleOpenPageChange = (index) => {
        const newPopoverOpenStates = [...openPage];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage(newPopoverOpenStates);
    };
    const ViewDetailPage = (id) => {
        setNotePopup(true)
        setPopupType("Update")
        setNoteValue(id)
        setPage("Entity")
        setNaCTrigger("trigger")
    }
    async function AllLeads(type, id) {
        try {
            const data = await FetchAllNotes(type, id);
            const SortedData = data.sort((a, b) => b.note_id - a.note_id);
            setLeads(SortedData);
        } catch (error) {
            message.error(error)
        }
    }
    async function AllUsersData() {
        try {
            const data = await getAllUsersData();
            setAllUsers(data);
        } catch (error) {
            message.error(error)
        }
    }
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2})/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    useEffect(() => {
        if (refreshTrigger === tabKey) {
            if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
                AllLeads("Lead", UrlId[1])
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                AllLeads("Deal", UrlId[1])
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
                AllLeads("Contact", UrlId[1])
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
                AllLeads("Account", UrlId[1])
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK") {
                AllLeads("Task", UrlId[1])
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?MEETING") {
                AllLeads("Meeting", UrlId[1])
            }
        }
    }, [UrlId, NacTrigger, refreshTrigger, tabKey])
    useEffect(() => {
        AllUsersData()
    }, [])
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";

        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);

        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }

        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone);

        // Get raw and formatted time
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        // Check if the date is today in the same target timezone
        const today = moment.tz(toTimezone).startOf('day');
        const isToday = converted.isSame(today, 'day');

        if (isToday) {
            return `Today, ${formattedTime}`;
        }
        const formattedDate = converted.format("MMM DD, YYYY");
        return `${formattedDate}, ${formattedTime}`;
    }
    return (
        <>
            {leads ? (leads?.length > 0 ?
                leads?.map((item, index) => {
                    const user = allUsers?.find(user => user.userId === item.created_by);
                    const Name = user ? `${user.firstName} ${user.lastName}` : "Unknown User";
                    const formattedTimeDifference = convertAndFormatDateTime2(item.created_at, companyProfile, profile)
                    return (
                        <div key={index} style={{ marginBottom: 15 }}>
                            <Card className="DetailsTabCard">
                                <Collapse bordered={false} className="DetailsTabCollapse">
                                    <Panel
                                        header={
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <NotesIcon height={16} width={16} marginRight={5} />
                                                <Text strongtitle={item.note_title}>{item.note_title.length > 30 ? `${item.note_title.slice(0, 30)}...` : item.note_title} <span style={{ color: "#adb4d2", marginRight: 3 }}>|</span> <span style={{ color: "#adb4d2", fontSize: 12, marginTop: "0.2rem" }}>{Name}</span></Text>
                                            </div>
                                        }
                                        key="1"
                                        extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} /> {formattedTimeDifference}
                                            </div>
                                            <Popover
                                                placement="bottom"
                                                content={
                                                    <div >
                                                        <Link to={combinedUrl} className="text_icon" onClick={() => { ViewDetailPage(item.note_id); handleOpenPageChange(index) }}>
                                                            <EditIcon height={16} width={16} marginRight={5} /> Edit
                                                        </Link>
                                                    </div>
                                                }
                                                trigger="hover"
                                                open={openPage[index]}
                                                onOpenChange={() => handleOpenPageChange(index)}
                                            >
                                                <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                            </Popover>
                                        </div>}
                                    >
                                        <Divider style={{ margin: 0 }} />
                                        <div style={{ marginTop: 10 }}>
                                            <Text type="secondary">{item.note_desc && item.note_desc !== "" ? <CustomHtmlParser html={item.note_desc} key={index} page="Previewss" /> : "Note Description"}</Text>
                                        </div>
                                    </Panel>
                                </Collapse>
                            </Card >
                        </div>
                    )
                }) :
                <div style={{ padding: "10%" }}>
                    <Empty />
                </div>)
                :
                <div className="spin">
                    <Spin />
                </div>
            }
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} noteValue={noteValue} AllNotes={AllLeads} page={page} setNaCTrigger={setNaCTrigger} />}
        </>
    );
}
LeadTable.propTypes = {
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(LeadTable)